import { Warehouse } from "lucide-react";

export const GarageNote = () => (
  <div data-testid="garage-note" className="bg-gradient-to-r from-blue-600/15 to-transparent border border-blue-500/30 rounded-xl p-6 sm:p-8 flex items-start gap-4">
    <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm p-2.5 shrink-0">
      <Warehouse className="h-5 w-5 text-blue-500" />
    </div>
    <div className="space-y-3">
      <p className="text-zinc-300 leading-relaxed text-sm sm:text-base">
        Most repairs can be completed wherever your vehicle is located. For larger repairs
        that require a lift, specialized equipment, or more workspace, Mason's Mobile can
        arrange service at our trusted local garage. This gives customers the convenience
        and personal service of a mobile mechanic while often saving money compared with
        dealership and large repair-shop pricing.
      </p>
      <p className="text-zinc-300 leading-relaxed text-sm sm:text-base" data-testid="garage-note-mission">
        The big shops carry way too much overhead — and their prices show it.
        <span className="text-white font-medium"> We're in business to actually help people:</span> honest
        diagnosis, fair pricing, and getting you back into a safe, drivable car without the insane repair bills.
      </p>
    </div>
  </div>
);
